"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePlatformMobileRules = resolvePlatformMobileRules;
exports.resolveEnabledMobileRules = resolveEnabledMobileRules;
const accessibility_standards_1 = require("@deque/accessibility-standards");
const mobilePlatform_1 = require("./mobilePlatform");
function resolvePlatformMobileRules(platform) {
    return Object.keys(platform === mobilePlatform_1.MobilePlatform.ANDROID ? accessibility_standards_1.androidRules : accessibility_standards_1.iosRules);
}
/**
 * The rule ids enabled for a platform after removing the config's disabled
 * rules and any additional per-scan overrides. iPadOS uses the iOS rule set and
 * the iOS disabled list.
 *
 * This is the single source of truth for mobile rule resolution, shared by the
 * backend session-init reconciliation and the front-end config-drift check.
 */
function resolveEnabledMobileRules(config, platform, additionalDisabledRules = []) {
    const isAndroid = platform === mobilePlatform_1.MobilePlatform.ANDROID;
    const disabledRules = new Set([
        ...(isAndroid
            ? config.androidDisabledRules.value
            : config.iosDisabledRules.value),
        ...additionalDisabledRules
    ]);
    return resolvePlatformMobileRules(platform).filter(ruleId => !disabledRules.has(ruleId));
}
//# sourceMappingURL=mobileRules.js.map